* {
    box-sizing: border-box;
}

:host {
    outline: none;
    --template-columns: repeat(auto-fill, minmax(280px, 1fr));
    --template-rows: initial;
    --gap: 20px;
}

:host(:focus-within) label:not(.disabled) {
    padding: 19px;
    border-width: 2px;
}

label {
    display: block;
    position: relative;
    border: 1px solid var(--color-shade-50);
    border-radius: 8px;
    padding: 20px;
    cursor: pointer;
    overflow: hidden;
    transition-property: border-color, filter;
    transition-duration: 500ms;
    transition-timing-function: ease;
    outline: none;

    & es-icon {
        box-sizing: border-box;
        background-color: var(--color-shade-50);
        color: var(--color-background);
        position: absolute;
        bottom: -11px;
        right: -10px;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        padding-top: 8px;
        padding-left: 8px;
        padding-right: 15px;
        padding-bottom: 15px;
        transition-property: transform, background-color, opacity;
        transition-duration: 500ms;
        transition-timing-function: ease;
        transform: translateX(50%) translateY(50%);
        opacity: 0;
    }

    &:not(.disabled) {
        &:hover,
        &:focus,
        &:focus-within {
            padding: 19px;
            border: 2px solid var(--color-success-alt);

            & es-icon {
                transform: translateX(20%) translateY(20%);
                background-color: var(--color-success-alt);
                opacity: 1;
            }
        }

        &.active {
            padding: 19px;
            border: 2px solid var(--color-success);

            & es-icon {
                transform: translateX(0%) translateY(0%);
                opacity: 1;
                background-color: var(--color-success);
            }
        }
    }

    &.disabled {
        cursor: not-allowed;
        color: var(--color-disabled-contrast);
        border-color: var(--color-disabled-border);
        background-color: var(--color-disabled);
        border-style: dashed;

        & > *:not(input, .no-fade, es-icon) {
            filter: grayscale(1);
            opacity: 0.8;
        }
    }
}

.group-inner {
    display: grid;
    grid-template-columns: var(--template-columns);
    grid-template-rows: var(--template-rows);
    gap: var(--gap);
}

input {
    position: absolute;
    opacity: 0;
    width: 0;
    bottom: 0;
}

.label {
    display: block;
    color: var(--color-text);
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 10px;
}

.description {
    display: block;
    color: var(--color-text);
    font-size: 26px;
    font-weight: 100;
}

.group-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--color-text);
    line-height: 1.5;

    text-align: left;
    text-transform: capitalize;
    padding: 20px 0;
    display: block;
}
